import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import {
  SecondAds,
  FirstAds,
  MobileUnderCalAds
} from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة الكربوهيدرات الالكترونية - تعلم كيفية حساب الكربوهيدرات";
const DESCRIPTION =
  "تقوم حاسبة الكربوهيدرات بمساعدتك في تثبيت, إنقاص او زيادة وزنك. حاسبة الكربوهيدرات هي أداة قيمة تساعد الأفراد على تحديد النسبة المثلى من الكربوهيدرات التي يجب عليهم تناولها يومياً.";
const KEYWORDS = "الكربوهيدرات, حساب الكربوهيدرات";
const OG_URL = "https://do-calculate.com/calculator/ar/carbohydrate/";
function CarbohydrateCalculator() {
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("male");
  const [height, setHeight] = useState("");
  const [weight, setWeight] = useState("");
  const [activity, setActivity] = useState("");
  const [result, setResult] = useState(null);
  const calculateCarbohydrates = () => {
    const genderFactor = gender === "male" ? 5 : -161;
    const calories = Math.round(
      10 * weight + 6.25 * height - 5 * age + genderFactor
    );
    const activityFactors = {
      sedentary: 1.2,
      lightlyActive: 1.375,
      moderatelyActive: 1.55,
      active: 1.725,
      veryActive: 1.9,
    };
    const tdee = calories * activityFactors[activity];
    const tdee_lose_0_5 = calories * activityFactors[activity] - 500;
    const tdee_lose_1 = calories * activityFactors[activity] - 1000;
    const tdee_gain_0_5 = calories * activityFactors[activity] + 500;
    const tdee_gain_1 = calories * activityFactors[activity] + 1000;
    const carbs40 = Math.round((tdee * 0.4) / 3.75);
    const carbs55 = Math.round((tdee * 0.55) / 3.75);
    const carbs65 = Math.round((tdee * 0.65) / 3.75);
    const carbs75 = Math.round((tdee * 0.75) / 3.75);
    const carbs40Lose0_5 = Math.round((tdee_lose_0_5 * 0.4) / 3.75);
    const carbs55Lose0_5 = Math.round((tdee_lose_0_5 * 0.55) / 3.75);
    const carbs65Lose0_5 = Math.round((tdee_lose_0_5 * 0.65) / 3.75);
    const carbs75Lose0_5 = Math.round((tdee_lose_0_5 * 0.75) / 3.75);
    const carbs40Lose1 = Math.round((tdee_lose_1 * 0.4) / 3.75);
    const carbs55Lose1 = Math.round((tdee_lose_1 * 0.55) / 3.75);
    const carbs65Lose1 = Math.round((tdee_lose_1 * 0.65) / 3.75);
    const carbs75Lose1 = Math.round((tdee_lose_1 * 0.75) / 3.75);
    const carbs40Gain0_5 = Math.round((tdee_gain_0_5 * 0.4) / 3.75);
    const carbs55Gain0_5 = Math.round((tdee_gain_0_5 * 0.55) / 3.75);
    const carbs65Gain0_5 = Math.round((tdee_gain_0_5 * 0.65) / 3.75);
    const carbs75Gain0_5 = Math.round((tdee_gain_0_5 * 0.75) / 3.75);
    const carbs40Gain1 = Math.round((tdee_gain_1 * 0.4) / 3.75);
    const carbs55Gain1 = Math.round((tdee_gain_1 * 0.55) / 3.75);
    const carbs65Gain1 = Math.round((tdee_gain_1 * 0.65) / 3.75);
    const carbs75Gain1 = Math.round((tdee_gain_1 * 0.75) / 3.75);
    return {
      goal: "Weight Maintenance",
      calories: tdee,
      carbs40,
      carbs55,
      carbs65,
      carbs75,
      carbs40Lose0_5,
      carbs55Lose0_5,
      carbs65Lose0_5,
      carbs75Lose0_5,
      carbs40Lose1,
      carbs55Lose1,
      carbs65Lose1,
      carbs75Lose1,
      carbs40Gain0_5,
      carbs55Gain0_5,
      carbs65Gain0_5,
      carbs75Gain0_5,
      carbs40Gain1,
      carbs55Gain1,
      carbs65Gain1,
      carbs75Gain1,
      tdee_lose_0_5,
      tdee_lose_1,
      tdee_gain_0_5,
      tdee_gain_1,
    };
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const result = calculateCarbohydrates();
    setResult(result);
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  تقوم حاسبة الكربوهيدرات بمساعدتك في تثبيت, إنقاص او زيادة
                  وزنك. حاسبة الكربوهيدرات هي أداة قيمة تساعد الأفراد على تحديد
                  النسبة المثلى من الكربوهيدرات التي يجب عليهم تناولها يومياً.
                  تعتبر الكربوهيدرات مصدرًا هامًا للطاقة في النظام الغذائي،
                  وتلعب دورًا كبيرًا في تلبية احتياجات الجسم اليومية. إذا تم
                  استهلاك الكربوهيدرات بشكل مناسب، فإنها يمكن أن تساعد في الحفاظ
                  على مستويات الطاقة والأداء الجسدي. تستند حاسبة الكربوهيدرات
                  إلى العديد من العوامل مثل العمر، والجنس، ومستوى النشاط البدني،
                  وأهداف الصحة الشخصية. من خلال إدخال هذه المعلومات، يمكن للفرد
                  الحصول على توجيه مخصص حول مقدار الكربوهيدرات التي يجب عليه
                  تضمينها في نظامه الغذائي يومياً.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  حساب الكربوهيدرات في الجسم
                </div>
                <hr />
                <br />
                <form onSubmit={handleSubmit}>
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label htmlFor="height" className="form-label ms-2">
                        الطول
                      </label>
                    </b>
                    <input
                      type="number"
                      id="weightNumber"
                      value={height}
                      onChange={(e) => setHeight(e.target.value)}
                      className="form-control ml-2"
                      style={{ width: "90%" }}
                      placeholder="175"
                    />
                    <div className="input-group-append">
                      <span className="input-group-text">سم</span>
                    </div>
                  </div>
                  <br />
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label htmlFor="weightNumber" className="form-label ms-2">
                        الوزن
                      </label>
                    </b>
                    <input
                      type="number"
                      id="weightNumber"
                      value={weight}
                      onChange={(e) => setWeight(e.target.value)}
                      className="form-control ml-2"
                      style={{ width: "90%" }}
                      placeholder="65"
                    />
                    <div className="input-group-append">
                      <span className="input-group-text">كغ</span>
                    </div>
                  </div>
                  <br />
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label htmlFor="age" className="form-label ms-2">
                        العمر
                      </label>
                    </b>
                    <input
                      type="number"
                      id="age"
                      value={age}
                      onChange={(e) => setAge(e.target.value)}
                      className="form-control"
                      style={{ width: "90%" }}
                      placeholder="6"
                    />
                  </div>
                  <br />
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label >الجنس</label>
                    </b>
                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        name="gender"
                        value="male"
                        id="male"
                        checked={gender === "male"}
                        onChange={(e) => setGender(e.target.value)}
                        className="form-check-input"
                      />
                      <label className="form-check-label" htmlFor="male">
                        ذكر
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        name="gender"
                        value="female"
                        id="female"
                        checked={gender === "female"}
                        onChange={(e) => setGender(e.target.value)}
                        className="form-check-input"
                      />
                      <label className="form-check-label" htmlFor="female">
                        أنثى
                      </label>
                    </div>
                  </div>
                  <br />
                  <div>
                    <b>
                      <label
                        className="form-label ms-2"
                        htmlFor="activitySelect"
                      >
                        معدل النشاط
                      </label>
                    </b>
                    <select
                      id="activitySelect"
                      className="form-select"
                      value={activity}
                      onChange={(e) => setActivity(e.target.value)}
                    >
                      <option value="">-- إختر النشاط --</option>
                      <option value="sedentary">
                        قليل النشاط: نشاط بدني ضئيل جدًا أو عدم ممارسة التمارين
                        الرياضية
                      </option>
                      <option value="lightlyActive">
                        متوسط النشاط: تمارين رياضية خفيفة أو نشاط بدني لمدة 1-3
                        أيام في الأسبوع
                      </option>
                      <option value="moderatelyActive">
                        نشاط معتدل: تمارين رياضية معتدلة أو نشاط بدني لمدة 3-5
                        أيام في الأسبوع
                      </option>
                      <option value="active">
                        نشاط مرتفع: ممارسة تمارين رياضية مكثفة أو نشاط بدني لمدة
                        6-7 أيام في الأسبوع
                      </option>
                      <option value="veryActive">
                        نشاط مكثف: تمارين رياضية مكثفة جدًا أو نشاط بدني قوي
                        يوميًا
                      </option>
                    </select>
                  </div>
                  <br />
                  <hr />
                  <button
                    type="submit"
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                  >
                    احسب
                  </button>
                </form>
              </div>
              <div className="col-12 col-md-7">
                {result && (
                  <table >
                    <thead>
                      <tr>
                        <th >الهدف</th>
                        <th >السعرات اليومية</th>
                        <th >40%</th>
                        <th >55%</th>
                        <th >65%</th>
                        <th >75%</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>الحفاظ على الوزن</td>
                        <td>{result.calories} سعرة</td>
                        <td>{result.carbs40} غ</td>
                        <td>{result.carbs55} غ</td>
                        <td>{result.carbs65} غ</td>
                        <td>{result.carbs75} غ</td>
                      </tr>
                      <tr>
                        <td>خسارة 0.5 كغ/اسبوع</td>
                        <td>{result.tdee_lose_0_5} سعرة</td>
                        <td>{result.carbs40Lose0_5} غ</td>
                        <td>{result.carbs55Lose0_5} غ</td>
                        <td>{result.carbs65Lose0_5} غ</td>
                        <td>{result.carbs75Lose0_5} غ</td>
                      </tr>
                      <tr>
                        <td>خسارة 1 كغ/اسبوع</td>
                        <td>{result.tdee_lose_1} سعرة</td>
                        <td>{result.carbs40Lose1} غ</td>
                        <td>{result.carbs55Lose1} غ</td>
                        <td>{result.carbs65Lose1} غ</td>
                        <td>{result.carbs75Lose1} غ</td>
                      </tr>
                      <tr>
                        <td>زيادة 0.5 كغ/اسبوع</td>
                        <td>{result.tdee_gain_0_5} سعرة</td>
                        <td>{result.carbs40Gain0_5} غ</td>
                        <td>{result.carbs55Gain0_5} غ</td>
                        <td>{result.carbs65Gain0_5} غ</td>
                        <td>{result.carbs75Gain0_5} غ</td>
                      </tr>
                      <tr>
                        <td>زيادة 1 كغ/اسبوع</td>
                        <td>{result.tdee_gain_1} سعرة</td>
                        <td>{result.carbs40Gain1} غ</td>
                        <td>{result.carbs55Gain1} غ</td>
                        <td>{result.carbs65Gain1} غ</td>
                        <td>{result.carbs75Gain1} غ</td>
                      </tr>
                    </tbody>
                  </table>
                )}
              </div>
            </div>
                        <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                كل ما تحتاج لمعرفته حول الكربوهيدرات: كيفية حسابها وأهميتها في
                نظامك الغذائي:
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    كل ما تحتاج لمعرفته حول الكربوهيدرات: كيفية حسابها وأهميتها
                    في نظامك الغذائي
                  </h2>{" "}
                </u>{" "}
                <br />
                <p>
                  الكربوهيدرات هي إحدى المكونات الأساسية في الغذاء، وهي تلعب
                  دورًا هامًا في تزويد الجسم بالطاقة والحفاظ على وظائفه الحيوية.
                  في هذه المقالة، سنستكشف عالم الكربوهيدرات وسنتعرف على كيفية
                  حسابها بشكل دقيق وأهميتها في نظامك الغذائي.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>مفهوم الكربوهيدرات</h2>{" "}
                </u>{" "}
                <br />
                <p>
                  الكربوهيدرات هي مركبات كيميائية تتكون من الكربون والهيدروجين
                  والأكسجين. تشمل الكربوهيدرات السكريات والنشويات والألياف،
                  وتوجد في العديد من الأطعمة مثل الخبز والأرز والفواكه
                  والخضروات.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    كيفية حساب الكربوهيدرات{" "}
                  </h2>{" "}
                </u>{" "}
                <br />
                <p>
                  هناك حاجة متزايدة لمعرفة كمية الكربوهيدرات التي يجب عليك
                  تناولها يومياً، وذلك لتحقيق توازن صحي في نظامك الغذائي. يمكن
                  حساب الكربوهيدرات عن طريق تتبع القوائم الغذائية على العبوات
                  واستخدام حاسبة الكربوهيدرات المتاحة عبر الإنترنت.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    أهمية الكربوهيدرات في الغذاء:
                  </h2>{" "}
                </u>{" "}
                <br />
                <p>
                  باختصار، الكربوهيدرات هي جزء أساسي من نظامك الغذائي وتأتي
                  بأهمية كبيرة لصحتك العامة وأدائك اليومي. من خلال معرفة كيفية
                  حسابها وتضمينها بشكل مناسب في وجباتك، يمكنك الاستمتاع بفوائدها
                  بشكل أفضل والعيش بصحة جيدة.
                </p>
                <hr />
              </div>
            </div>
          </div>
          <br />
          <u>
            {" "}
            <h2>اسئلة متكررة</h2>
          </u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ما هي كمية الكربوهيدرات التي يجب أن تستهلكها؟
                </h3>
              </div>
              <div className="info-section-body">
                هناك عدد من العوامل التي تؤثر على كمية الكربوهيدرات التي
                نحتاجها، بما في ذلك الفرد وكثافة التمرين ومدته، ولكن بشكل عام
                بالنسبة للرياضي، يجب أن يكون 60-70 في المائة من الطاقة من
                الكربوهيدرات. تتطلب التمارين عالية الكثافة لمدة 1-3 ساعات
                تقريبًا 6-10 جرام لكل كجم من كتلة الجسم، مقارنة بالتمرين منخفض
                الكثافة الذي يحتاج فقط إلى 3-5 جرام لكل كجم من كتلة الجسم. يعتمد
                تناول الكربوهيدرات على نوع وكثافة ومدة التمرين، حيث تزيد كمية
                الكربوهيدرات المتناولة عند زيادة شدة التمرين. يعد المدربون
                والتخطيط مفيدًا جدًا لمساعدتك في حساب كمية الكربوهيدرات التي
                ستحتاجها أثناء تمرينك، حيث أن استنفاد الكربوهيدرات سيؤدي إلى
                استخدام الجسم لمخزونه من الدهون والبروتين كوقود، مما قد يؤدي إلى
                حرق العضلات كوقود بدلاً من الطعام.{" "}
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  كيف تؤثر الكربوهيدرات على نمو العضلات؟
                </h3>
              </div>
              <div className="info-section-body">
                يعتقد بعض الناس أنه لبناء العضلات بسرعة، يجب التضحية
                بالكربوهيدرات لحرق الدهون كوقود وتعبئة البروتين بدلاً من ذلك
                للمساعدة في نمو العضلات. وهذا صحيح عندما يحاول الرياضيون
                الاستلقاء لفترة قصيرة من الوقت، ولكن طوال معظم العام، عند محاولة
                بناء العضلات وتوسيع النمو، فإن اتباع نظام غذائي معتدل إلى عالي
                الكربوهيدرات هو أفضل أسلوب. إن مستويات الطاقة الأعلى وزيادة دعم
                العضلات وزيادة معدل الاستشفاء ومنع انهيار العضلات كلها أمور
                مضمونة عند تناول الكربوهيدرات. خلافًا للاعتقاد الشائع، يمكن
                للكربوهيدرات أن تساعد في نمو عضلاتك مما يجعلها أقوى، ويجب
                بالتأكيد تضمينها في نظامك الغذائي.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ماذا يحدث عند استخدام جميع الكربوهيدرات؟
                </h3>
              </div>
              <div className="info-section-body">
                ينخفض أدائك أولاً عندما تتخطى كل الكربوهيدرات أو تستهلكها، وتصبح
                حركات العضلات والتحفيز أكثر صعوبة، مما قد يؤثر بعد ذلك على
                الأداء. عندما يتم استخدام مخزون الكربوهيدرات، سيستخدم الجسم
                البروتين كمصدر للطاقة، مما سيؤثر لاحقًا على قدرته على اكتساب
                العضلات ودعمها. يمكن أن يسبب حرق البروتين كطاقة المزيد من
                المشاكل، فعندما يحاول جسمك التخلص من المنتجات الثانوية للبروتين،
                يتعين على الكليتين العمل بجهد أكبر، مما يسبب التوتر الذي قد يؤدي
                إلى إتلافها. تساعد الكربوهيدرات أيضًا على تغذية الدماغ والجهاز
                العصبي المركزي، وعندما تنفد الكربوهيدرات لديك، يمكن أن يؤثر ذلك
                على أدائهما ويمكن أن يؤدي في الحالات الخطيرة إلى مزيد من
                المشاكل.{" "}
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default CarbohydrateCalculator;
